<template>
  <div>
    <v-simple-table class="ma-4 produtos-table">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left" style="min-width: 400px">Produto</th>
          <th class="text-left" style="min-width: 30px">Quantidade</th>
          <th style="min-width: 60px">Unidade de medida</th>
          <th style="min-width: 200px">Especificação</th>
          <th style="min-width: 138px"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(produto, index) in cotacao.produtos"
            :key="produto.$$id"
            style="height: 60px">
            <px-cadastro-cotacao-produtos-table-item ref="produtos"
                                                     :is-rascunho="isRascunho"
                                                     :produto="produto"
                                                     :is-from-requisicao="isFromRequisicao"
                                                     :campos-readonly="camposReadonly"
                                                     :campos-obrigatorios="camposObrigatorios"
                                                     :erp-campos-integracao="erpCamposIntegracao"
                                                     :hide-acoes="hideAcoes"
                                                     @remove-produto="removeProduto(index)"
                                                     @replicar-campo="onReplicarCampo"
                                                     @duplicar-produto="duplicar"/>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row dense v-if="!hideAcoes">
      <v-col cols="12" class="text-right">
        <v-btn small
               color="primary"
               class="rounded-tag-small normal-btn-text elevation-0"
               @click="adicionarProduto">
          <v-icon small>mdi-plus</v-icon>
          Produto
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             @click="next">
        Continuar
        </v-btn>
        <v-btn text
              class="normal-btn-text"
              @click="previous">
          Voltar
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  isEmpty,
  isEqual,
  cloneDeep,
} from 'lodash';
import { isSameDate } from '@/utils/date-utils';
import validationMixin from '@/mixins/validation-mixin';
import { replicarCampoProdutos } from '@/utils/cadastros-adicionais-utils';
import CadastroCotacaoProdutosTableItem from './CadastroCotacaoProdutosTableItem.vue';
import { copyProduto, initialStateProduto } from '../utils/cotacao-utils';

export default {
  mixins: [validationMixin],
  props: {
    cotacao: Object,
    isFromRequisicao: {
      type: Boolean,
      default: false,
    },
    camposReadonly: {
      type: Object,
      default: null,
    },
    camposObrigatorios: {
      type: Object,
      default: null,
    },
    hideAcoes: {
      type: Boolean,
      default: false,
    },
    erpCamposIntegracao: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isRascunho: this.$route.params.isRascunho,
    };
  },
  methods: {
    onReplicarCampo(campo) {
      this.cotacao.produtos = replicarCampoProdutos(this.cotacao.produtos, campo);
    },
    isFormValid() {
      return this.$refs.produtos
        .map(produto => produto.validate())
        .every(validation => validation);
    },
    next() {
      if (!this.isFormValid()) {
        return;
      }
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    },
    getFinalidadeFromProduto(currentProduto, newProduto) {
      if (newProduto.produto) {
        return newProduto.produto.finalidadeCompra
          ? newProduto.produto.finalidadeCompra : currentProduto.finalidadeCompra;
      }
      return currentProduto.finalidadeCompra;
    },
    duplicar(produto) {
      const newProduto = {
        ...copyProduto(produto, this.cotacao),
        id: undefined,
        requisicaoProduto: undefined,
      };
      this.cotacao.produtos.push(cloneDeep(newProduto));
    },
    adicionarProduto() {
      this.cotacao.produtos.push({
        ...initialStateProduto(this.cotacao, this.erpCamposIntegracao),
      });
    },
    clearProjetoProdutos(oldProjeto) {
      this.cotacao.produtos = this.cotacao.produtos.map((produto) => {
        const produtoProjetoId = produto.projeto ? produto.projeto.id : null;
        const isSame = oldProjeto.id === produtoProjetoId;

        return {
          ...produto,
          projeto: isSame ? null : produto.projeto,
        };
      });
    },
    setProjetoProdutos(oldProjeto, newProjeto) {
      this.cotacao.produtos = this.cotacao.produtos.map(produto => ({
        ...produto,
        projeto: this.getProjeto(produto, oldProjeto, newProjeto),
      }));
    },
    getProjeto(produto, oldProjeto, newProjeto) {
      const oldProjetoId = oldProjeto ? oldProjeto.id : null;
      if (produto.projeto === null || produto.projeto.id === oldProjetoId) {
        return newProjeto;
      }
      return produto.projeto;
    },
    clearCentroCustoProdutos(oldCentroCusto) {
      this.cotacao.produtos = this.cotacao.produtos.map((produto) => {
        const produtoCentroCustoId = produto.centroCusto ? produto.centroCusto.id : null;
        const isSame = oldCentroCusto.id === produtoCentroCustoId;

        return {
          ...produto,
          centroCusto: isSame ? null : produto.centroCusto,
        };
      });
    },
    setCentroCustoProdutos(oldCentroCusto, newCentroCusto) {
      this.cotacao.produtos = this.cotacao.produtos.map(produto => ({
        ...produto,
        centroCusto: this.getCentroCusto(produto, oldCentroCusto, newCentroCusto),
      }));
    },
    getCentroCusto(produto, oldCentroCusto, newCentroCusto) {
      const oldCentroCustoId = oldCentroCusto ? oldCentroCusto.id : null;
      if (produto.centroCusto === null || produto.centroCusto.id === oldCentroCustoId) {
        return newCentroCusto;
      }
      return produto.centroCusto;
    },
    getFinalidadeCompra(produto, newFinalidade, oldFinalidade) {
      if (!produto.finalidadeCompra) {
        const finalidadeCompra = produto.produto ? produto.produto.finalidadeCompra : newFinalidade;
        return finalidadeCompra;
      }
      if (isEqual(produto.finalidadeCompra, oldFinalidade)) {
        return newFinalidade;
      }
      return produto.finalidadeCompra;
    },
    setFinalidadeCompraProdutos(newFinalidade, oldFinalidade) {
      this.cotacao.produtos = this.cotacao.produtos.map(produto => ({
        ...produto,
        finalidadeCompra: this.getFinalidadeCompra(produto, newFinalidade, oldFinalidade),
      }));
    },
    getDataEntregaProduto(produto, oldData, newData) {
      if (!produto.dataPrevisaoEntrega || isSameDate(produto.dataPrevisaoEntrega, oldData)) {
        return newData;
      }
      return produto.dataPrevisaoEntrega;
    },
    setDataEntregaProdutos(newData, oldData) {
      this.cotacao.produtos = this.cotacao.produtos.map(produto => ({
        ...produto,
        dataPrevisaoEntrega: this.getDataEntregaProduto(produto, oldData, newData),
      }));
    },
    removeProduto(index) {
      if (this.cotacao.produtos.length <= 1) {
        return;
      }
      this.cotacao.produtos.splice(index, 1);
    },
    hasFileLoading() {
      return !isEmpty(this.cotacao.produtos.filter(p => p.$$hasFileLoading));
    },
    hasQuantidadeProduto() {
      return !isEmpty(this.cotacao.produtos.find(p => p.quantidade <= 0));
    },
  },
  watch: {
    'cotacao.projeto': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue === undefined && oldValue) {
        this.clearProjetoProdutos(oldValue);
        return;
      }
      this.setProjetoProdutos(oldValue, newValue);
    },
    'cotacao.centroCusto': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue === undefined && oldValue) {
        this.clearCentroCustoProdutos(oldValue);
        return;
      }
      this.setCentroCustoProdutos(oldValue, newValue);
    },
    'cotacao.finalidadeCompra': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.setFinalidadeCompraProdutos(newValue, oldValue);
    },
    'cotacao.prazoEntrega': function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.setDataEntregaProdutos(newValue, oldValue);
    },
  },
  components: {
    pxCadastroCotacaoProdutosTableItem: CadastroCotacaoProdutosTableItem,
  },
};
</script>

<style scoped>
.table-line {
  min-height: 55px;
  height: 55px
}

.produtos-table tr:hover:not(.v-table__expanded__content) {
  background: white !important;
}
</style>
